import React, {useCallback, useContext, useEffect, useState} from 'react';
import {AuthContext} from "../../../../shared/contexts/authContext";
import {PlayerContext} from "../../../../shared/contexts/playerContext";
import {useItemKrTextData} from "../../../probability/useItemData";
import {Button, Descriptions, Popconfirm, Select, Table, Tag, Typography} from "antd";
import IsLoading from "../../../../shared/components/IsLoading";
import ErrorPage from "../../../../shared/components/ErrorPage";
import {useGetPlayerShoppingRoadData, useSetShoppingRoadRestart, useSetShoppingRoadRestore} from "../../usePlayerData";
import {useFetchShoppingRoadGroupInfo} from "../../../events/shoppingRoad/useShoppingRoad";
import {useEventTable} from "../../../events/useEventTable";
import {parseRewards} from "../../../../shared/utils/shoppingRoadUtils";

const setShoppingRoadData = (playerInfo) => {
    let result = {...(playerInfo?.liveEventCache?.ShoppingRoadData || {})};

    if (playerInfo?.liveEventCache?.ShoppingRoadBackupDatas) {
        Object.keys(playerInfo.liveEventCache.ShoppingRoadBackupDatas).forEach(seq => {
            result[`${seq}.backup`] = playerInfo.liveEventCache.ShoppingRoadBackupDatas[seq];
        });
    }

    return result;
}

const getCurrentShoppingRoadSeq = (playerInfo) => {
    let seq = 0;
    if (playerInfo?.liveEventCache?.ShoppingRoadData) {
        seq = Object.keys(playerInfo.liveEventCache.ShoppingRoadData)[0];
    }
    return seq;
}
const PlayerShoppingRoad = () => {
    const {currentUser} = useContext(AuthContext);
    const {playerData} = useContext(PlayerContext);

    const [shoppingRoadData] = useState(setShoppingRoadData(playerData.playerInfo));
    const [currentShoppingRoadSeq, setCurrentShoppingRoadSeq] = useState(getCurrentShoppingRoadSeq(playerData.playerInfo));
    const [rowData, setRowData] = useState([]);
    const {
        data: playerShoppingRoadData,
        isLoading: isPlayerShoppingRoadLoading,
        error: playerShoppingRoadError
    } = useGetPlayerShoppingRoadData({
        userKey: playerData.userKey, shoppingRoadSeq: currentShoppingRoadSeq
    });
    const {
        data: shoppingRoadGroupData,
        isLoading: isShoppingRoadGroupDataLoading,
        error: shoppingRoadGroupDataError
    } = useFetchShoppingRoadGroupInfo({
        shoppingRoadSeq: currentShoppingRoadSeq,
        difficult: playerShoppingRoadData?.difficult
    }, {
        enabled: !!playerShoppingRoadData?.difficult
    });
    const {data: eventTable, isLoading: isEventTableLoading, error: eventTableError} = useEventTable();
    const {data: itemRaw} = useItemKrTextData();
    const itemData = itemRaw?.[currentUser?.target] || [];

    const renderRewards = useCallback((r) => {
        const rewards = parseRewards(r);
        if (!rewards.length) return '-';
        return rewards.map((rw, i) => {
            const item = itemData.find(d => d.index === rw.id && d.itemType === rw.type);
            const label = item ? `${item.name}(${rw.id})` : `${rw.id}`;
            return (
                <span key={i} style={{marginRight: 4}}>
                    {label} x {rw.quantity}{i < rewards.length - 1 ? ',' : ''}
                </span>
            );
        });
    }, [itemData]);

    useEffect(() => {
        const tempShoppingRoadData = {...shoppingRoadGroupData};
        if (shoppingRoadData && tempShoppingRoadData) {
            const curStep = playerShoppingRoadData?.step || 0;
            Object.values(tempShoppingRoadData).forEach((item, index) => {
                console.log(index, curStep)
                if (index < curStep - 1) {
                    item.state = 3;
                } else if (index === curStep - 1) {
                    item.state = 1;
                } else {
                    item.state = 0;
                }
            })
            console.log(tempShoppingRoadData);
        }
        setRowData(Object.values(tempShoppingRoadData || {}));
    }, [shoppingRoadGroupData, playerShoppingRoadData, shoppingRoadData, currentShoppingRoadSeq]);

    const activeSeq = Object.keys(playerData.playerInfo?.liveEventCache?.ShoppingRoadData || {})[0];
    const backupData = playerData.playerInfo?.liveEventCache?.ShoppingRoadBackupDatas?.[activeSeq];
    const hasBackupData = !!backupData;

    const restartMutation = useSetShoppingRoadRestart({userKey: playerData.userKey, shoppingRoadSeq: activeSeq});
    const restoreMutation = useSetShoppingRoadRestore({userKey: playerData.userKey, shoppingRoadSeq: activeSeq});
    const stateText = {
        0: {text: '닫힘', color: 'default'},
        1: {text: '진행 중', color: 'blue'},
        2: {text: '완료', color: 'green'},
        3: {text: '보상받음', color: 'gold'},
    };

    const columns = [
        {
            title: '번호',
            dataIndex: 'groupSeq',
            key: 'groupSeq',
            width: 200,
        },
        {
            title: '이벤트 명',
            dataIndex: 'eventName',
            key: 'eventName',
            render: (_, {eventIdx, rewards}) => {
                if (eventIdx === 0) {
                    return renderRewards(rewards);
                } else {
                    return eventTable[eventIdx].nameText;
                }
            },
        },
        {
            title: '상태',
            dataIndex: 'state',
            key: 'state',
            width: 120,
            render: (state) => {
                const info = stateText[state] || {text: state, color: 'default'};
                return <Tag color={info.color}>{info.text}</Tag>;
            },
        }
    ];

    if (isPlayerShoppingRoadLoading || isShoppingRoadGroupDataLoading || isEventTableLoading) return <IsLoading/>;
    const error = playerShoppingRoadError || shoppingRoadGroupDataError || eventTableError;
    if (error) return <ErrorPage error={error}/>;

    return (
        <div>
            쇼핑로드 시퀀스 선택:
            <Select
                value={currentShoppingRoadSeq}
                onChange={(value) => {
                    setCurrentShoppingRoadSeq(value)
                }}
                style={{minWidth: 120}}
                size="small"
            >
                {Object.keys(shoppingRoadData).map(option => (
                    <Select.Option key={option} value={option}>
                        {option}
                    </Select.Option>
                ))}
            </Select>
            <Descriptions title="쇼핑로드 정보" bordered size="small" style={{marginBottom: 16}}>
                <Descriptions.Item label="시즌">{playerShoppingRoadData?.shoppingRoadSeq}</Descriptions.Item>
                <Descriptions.Item label="난이도">{playerShoppingRoadData?.difficult}</Descriptions.Item>
                <Descriptions.Item label="쇼핑로드 시작 일자">{playerShoppingRoadData?.created}</Descriptions.Item>
                <Descriptions.Item label="재시작 횟수">{playerShoppingRoadData?.restartCnt}</Descriptions.Item>
                <Descriptions.Item label="재선택 횟수">{playerShoppingRoadData?.refreshCnt}</Descriptions.Item>
                <Descriptions.Item label="쇼핑로드 관리" span={3}>
                    <div style={{display: 'flex', gap: 8, alignItems: 'center'}}>
                        <Popconfirm
                            title="쇼핑로드를 초기화하시겠습니까?"
                            onConfirm={() => restartMutation.mutate({
                                userKey: playerData.userKey,
                                shoppingRoadSeq: activeSeq
                            })}
                            okText="확인"
                            cancelText="취소"
                        >
                            <Button danger size="small" loading={restartMutation.isPending}>쇼핑로드 초기화</Button>
                        </Popconfirm>
                        {hasBackupData ? (
                            <Popconfirm
                                title="쇼핑로드를 복구하시겠습니까?"
                                onConfirm={() => restoreMutation.mutate({
                                    userKey: playerData.userKey,
                                    shoppingRoadSeq: activeSeq,
                                    step: backupData.completeEvents.length,
                                    difficult: backupData.lastSelectDifficulty
                                })}
                                okText="확인"
                                cancelText="취소"
                            >
                                <Button size="small" loading={restoreMutation.isPending}>쇼핑로드 복구</Button>
                            </Popconfirm>
                        ) : (
                            <span style={{color: '#999'}}>복구할 데이터가 없습니다</span>
                        )}
                    </div>
                </Descriptions.Item>
            </Descriptions>
            <Table
                columns={columns}
                dataSource={rowData}
                pagination={false}
                bordered
                size="small"
            />
        </div>
    );
};

export default PlayerShoppingRoad;